






















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import _ from 'lodash'

const DashboardModule = namespace('DashboardModule')

@Component({})
export default class Dashboard extends Vue {

    @DashboardModule.Getter('totalStatsDeklaracje') totalStatsDeklaracje!: number;
    @DashboardModule.Getter('totalStatsDeklaracjeUpdatedAt') totalStatsDeklaracjeUpdatedAt!: string;
    @DashboardModule.Getter('totalStatsDeklaracjeLoading') totalStatsDeklaracjeLoading!: boolean;
    @DashboardModule.Action('getTotalStatsDeklaracje') getTotalStatsDeklaracje: any;
    @DashboardModule.Action('refreshTotalStatsDeklaracje') refreshTotalStatsDeklaracje: any;

    @DashboardModule.Getter('totalStatsPobrania') totalStatsPobrania!: number;
    @DashboardModule.Getter('totalStatsPobraniaUpdatedAt') totalStatsPobraniaUpdatedAt!: string;
    @DashboardModule.Getter('totalStatsPobraniaLoading') totalStatsPobraniaLoading!: boolean;
    @DashboardModule.Action('getTotalStatsPobrania') getTotalStatsPobrania: any;
    @DashboardModule.Action('refreshTotalStatsPobrania') refreshTotalStatsPobrania: any;

    @DashboardModule.Getter('totalStatsUruchomienia') totalStatsUruchomienia!: number;
    @DashboardModule.Getter('totalStatsUruchomieniaUpdatedAt') totalStatsUruchomieniaUpdatedAt!: string;
    @DashboardModule.Getter('totalStatsUruchomieniaLoading') totalStatsUruchomieniaLoading!: boolean;
    @DashboardModule.Action('getTotalStatsUruchomienia') getTotalStatsUruchomienia: any;
    @DashboardModule.Action('refreshTotalStatsUruchomienia') refreshTotalStatsUruchomienia: any;

    @DashboardModule.Getter('totalStatsDeklaracjeDifferenceComparedToLastYear') totalStatsDeklaracjeDifferenceComparedToLastYear!: number;
    @DashboardModule.Getter('totalStatsDeklaracjeLastYearUpdatedAt') totalStatsDeklaracjeLastYearUpdatedAt!: string;
    @DashboardModule.Getter('totalStatsDeklaracjeLastYearLoading') totalStatsDeklaracjeLastYearLoading!: boolean;
    @DashboardModule.Action('refreshTotalStatsDeklaracjeLastYear') refreshTotalStatsDeklaracjeLastYear: any;

    aggregatedStatsDeklaracjeDatasetsCloned: object = {};
    @DashboardModule.Getter('aggregatedStatsDeklaracjeLoading') aggregatedStatsDeklaracjeLoading!: boolean;
    @DashboardModule.Getter('aggregatedStatsDeklaracjeDatasets') aggregatedStatsDeklaracjeDatasets!: object;
    @DashboardModule.Getter('aggregatedStatsDeklaracjeDateTo') aggregatedStatsDeklaracjeDateTo!: string;
    @DashboardModule.Getter('aggregatedStatsDeklaracjeUpdatedAt') aggregatedStatsDeklaracjeUpdatedAt!: string;
    @DashboardModule.Action('getAggregatedStatsDeklaracje') getAggregatedStatsDeklaracje: any;
    @DashboardModule.Action('getAggregatedStatsDeklaracjeLastYear') getAggregatedStatsDeklaracjeLastYear: any;
    @DashboardModule.Action('loadPreviousAggregatedStatsDeklaracje') loadPreviousAggregatedStatsDeklaracje: any;
    @DashboardModule.Action('loadNextAggregatedStatsDeklaracje') loadNextAggregatedStatsDeklaracje: any;
    @DashboardModule.Action('refreshAggregatedStatsDeklaracje') refreshAggregatedStatsDeklaracje: any;

    aggregatedStatsUruchomieniaDatasetsCloned: object = {};
    @DashboardModule.Getter('aggregatedStatsUruchomieniaLoading') aggregatedStatsUruchomieniaLoading!: boolean;
    @DashboardModule.Getter('aggregatedStatsUruchomieniaDatasets') aggregatedStatsUruchomieniaDatasets!: object;
    @DashboardModule.Getter('aggregatedStatsUruchomieniaDateTo') aggregatedStatsUruchomieniaDateTo!: string;
    @DashboardModule.Getter('aggregatedStatsUruchomieniaUpdatedAt') aggregatedStatsUruchomieniaUpdatedAt!: string;
    @DashboardModule.Action('getAggregatedStatsUruchomienia') getAggregatedStatsUruchomienia: any;
    @DashboardModule.Action('getAggregatedStatsUruchomieniaLastYear') getAggregatedStatsUruchomieniaLastYear: any;
    @DashboardModule.Action('loadPreviousAggregatedStatsUruchomienia') loadPreviousAggregatedStatsUruchomienia: any;
    @DashboardModule.Action('loadNextAggregatedStatsUruchomienia') loadNextAggregatedStatsUruchomienia: any;
    @DashboardModule.Action('refreshAggregatedStatsUruchomienia') refreshAggregatedStatsUruchomienia: any;

    statsTopOperatingSystemsDatasetCloned: object = {};
    @DashboardModule.Getter('statsTopOperatingSystemsLoading') statsTopOperatingSystemsLoading!: boolean;
    @DashboardModule.Getter('statsTopOperatingSystemsDataset') statsTopOperatingSystemsDataset!: object;
    @DashboardModule.Getter('statsTopOperatingSystemsUpdatedAt') statsTopOperatingSystemsUpdatedAt!: string;
    @DashboardModule.Action('getStatsTopOperatingSystems') getStatsTopOperatingSystems: any;
    @DashboardModule.Action('refreshStatsTopOperatingSystems') refreshStatsTopOperatingSystems: any;

    statsTopBrowsersDataCloned: object = {};
    statsTopBrowsersAggregatedDataCloned: object = {};
    @DashboardModule.Getter('statsTopBrowsersLoading') statsTopBrowsersLoading!: boolean;
    @DashboardModule.Getter('statsTopBrowsersPageLoading') statsTopBrowsersPageLoading!: boolean;
    @DashboardModule.Getter('statsTopBrowsersData') statsTopBrowsersData!: object;
    @DashboardModule.Getter('statsTopBrowsersPage') statsTopBrowsersPage!: number;
    @DashboardModule.Getter('statsTopBrowsersCurrentPage') statsTopBrowsersCurrentPage!: number;
    @DashboardModule.Getter('statsTopBrowsersTotal') statsTopBrowsersTotal!: number;
    @DashboardModule.Action('getStatsTopBrowsers') getStatsTopBrowsers: any;
    @DashboardModule.Getter('statsTopBrowsersAggregatedData') statsTopBrowsersAggregatedData!: object;
    @DashboardModule.Action('getStatsTopBrowsersAggregated') getStatsTopBrowsersAggregated: any;

    statsTopIPDataCloned: object = {};
    @DashboardModule.Getter('statsTopIPLoading') statsTopIPLoading!: boolean;
    @DashboardModule.Getter('statsTopIPPageLoading') statsTopIPPageLoading!: boolean;
    @DashboardModule.Getter('statsTopIPData') statsTopIPData!: object;
    @DashboardModule.Getter('statsTopIPPage') statsTopIPPage!: number;
    @DashboardModule.Getter('statsTopIPCurrentPage') statsTopIPCurrentPage!: number;
    @DashboardModule.Getter('statsTopIPTotal') statsTopIPTotal!: number;
    @DashboardModule.Action('getStatsTopIP') getStatsTopIP: any;

    statsTopPobraniaReferersDataCloned: object = {};
    @DashboardModule.Getter('statsTopPobraniaReferersLoading') statsTopPobraniaReferersLoading!: boolean;
    @DashboardModule.Getter('statsTopPobraniaReferersPageLoading') statsTopPobraniaReferersPageLoading!: boolean;
    @DashboardModule.Getter('statsTopPobraniaReferersData') statsTopPobraniaReferersData!: object;
    @DashboardModule.Getter('statsTopPobraniaReferersPage') statsTopPobraniaReferersPage!: number;
    @DashboardModule.Getter('statsTopPobraniaReferersCurrentPage') statsTopPobraniaReferersCurrentPage!: number;
    @DashboardModule.Getter('statsTopPobraniaReferersTotal') statsTopPobraniaReferersTotal!: number;
    @DashboardModule.Action('getStatsTopPobraniaReferers') getStatsTopPobraniaReferers: any;

    chartOptions :object = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: true
                }
            }],
            xAxes: [{
                gridLines: {
                    display: false
                }
            }]
        },
        legend: {
            display: true
        },
        responsive: true,
        maintainAspectRatio: false
    };

    created() {
       this.getTotalStatsDeklaracje();
       this.getTotalStatsPobrania();
       this.getTotalStatsUruchomienia();
       this.getAggregatedStatsDeklaracje();
       this.getAggregatedStatsDeklaracjeLastYear();
       this.getAggregatedStatsUruchomienia();
       this.getAggregatedStatsUruchomieniaLastYear();
       this.getStatsTopOperatingSystems();
       this.getStatsTopBrowsersAggregated();
    }

    get pieChartOptions(): object {
        let pieChartOptions: object = _.cloneDeep(this.chartOptions);
        if (_.has(pieChartOptions, 'scales')) _.unset(pieChartOptions, 'scales');
        return pieChartOptions;
    }

    @Watch('aggregatedStatsDeklaracjeDatasets')
    onAggregatedStatsDeklaracjeDatasets() {
        // prevent mutating store by Chart.js
        let aggregatedStatsDeklaracjeDatasetsCloned: object = _.cloneDeep(this.aggregatedStatsDeklaracjeDatasets);
        if (!_.isEmpty(aggregatedStatsDeklaracjeDatasetsCloned))
            this.aggregatedStatsDeklaracjeDatasetsCloned = aggregatedStatsDeklaracjeDatasetsCloned;
    }

    @Watch('aggregatedStatsUruchomieniaDatasets')
    onAggregatedStatsUruchomieniaDatasets() {
        let aggregatedStatsUruchomieniaDatasetsCloned: object = _.cloneDeep(this.aggregatedStatsUruchomieniaDatasets);
        if (!_.isEmpty(aggregatedStatsUruchomieniaDatasetsCloned))
            this.aggregatedStatsUruchomieniaDatasetsCloned = aggregatedStatsUruchomieniaDatasetsCloned;
    }

    @Watch('statsTopOperatingSystemsDataset')
    onStatsTopOperatingSystemsDataset() {
        let statsTopOperatingSystemsDatasetCloned: object = _.cloneDeep(this.statsTopOperatingSystemsDataset);
        if (!_.isEmpty(statsTopOperatingSystemsDatasetCloned))
            this.statsTopOperatingSystemsDatasetCloned = statsTopOperatingSystemsDatasetCloned;
    }

    @Watch('statsTopBrowsersData')
    onStatsTopBrowsersData() {
        let statsTopBrowsersDataCloned: object = _.cloneDeep(this.statsTopBrowsersData);
        if (!_.isEmpty(statsTopBrowsersDataCloned))
            this.statsTopBrowsersDataCloned = statsTopBrowsersDataCloned;
    }

    @Watch('statsTopBrowsersAggregatedData')
    onStatsTopBrowsersAggregatedData() {
        let statsTopBrowsersAggregatedDataCloned: object = _.cloneDeep(this.statsTopBrowsersAggregatedData);
        if (!_.isEmpty(statsTopBrowsersAggregatedDataCloned))
            this.statsTopBrowsersAggregatedDataCloned = statsTopBrowsersAggregatedDataCloned;
    }

    @Watch('statsTopIPData')
    onStatsTopIPData() {
        let statsTopIPDataCloned: object = _.cloneDeep(this.statsTopIPData);
        if (!_.isEmpty(statsTopIPDataCloned))
            this.statsTopIPDataCloned = statsTopIPDataCloned;
    }

    @Watch('statsTopPobraniaReferersData')
    onStatsTopPobraniaReferersData() {
        let statsTopPobraniaReferersDataCloned: object = _.cloneDeep(this.statsTopPobraniaReferersData);
        if (!_.isEmpty(statsTopPobraniaReferersDataCloned))
            this.statsTopPobraniaReferersDataCloned = statsTopPobraniaReferersDataCloned;
    }

}
